import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = r((o, a) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: a,
    ...o,
    image: (t) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm13 2H2v2h12z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
l.displayName = "PaymentIcon";
export {
  l as PaymentIcon,
  l as default
};
//# sourceMappingURL=index.js.map
